/**
 * Hybrid Breadcrumb Component
 * Automatically chooses between Tailwind and styled-components based on props
 */

import * as React from "react";
import Nav from "./styles"; // Styled-components version
import { BreadcrumbTailwind } from "./BreadcrumbTailwind"; // Tailwind version
import { BreadcrumbList } from "./BreadcrumbList";
import { hasStyledProps } from "@sproutsocial/seeds-react-system-props";
import type { TypeBreadcrumbProps } from "./BreadcrumbTypes";

const BreadcrumbHybrid = ({
  ariaLabel,
  overflow,
  children,
  ...rest
}: TypeBreadcrumbProps) => {
  if (hasStyledProps(rest)) {
    return (
      <Nav aria-label={ariaLabel} data-qa-breadcrumb={ariaLabel} {...rest}>
        <BreadcrumbList overflow={overflow}>{children}</BreadcrumbList>
      </Nav>
    );
  }

  // Use Tailwind version (preferred - better performance)
  return (
    <BreadcrumbTailwind ariaLabel={ariaLabel} overflow={overflow} {...rest}>
      {children}
    </BreadcrumbTailwind>
  );
};

export default BreadcrumbHybrid;
